import { createReducer, on } from '@ngrx/store';

import {
  SubscriptionsActions,
  SubscriptionsApiActions,
} from './subscriptions.actions';
import { SubscriptionsState } from './subscriptions.state';

const initialSubscriptionsState: SubscriptionsState = {
  isLoadingActiveSubscription: false,
  activeSubscription: null,
  isLoadingFormerSubscriptions: false,
  formerSubscriptions: [],
};

export const subscriptionsReducer = createReducer<SubscriptionsState>(
  initialSubscriptionsState,
  on(
    SubscriptionsApiActions.fetchActiveSubscription,
    (state): SubscriptionsState => {
      return {
        ...state,
        isLoadingActiveSubscription: true,
      };
    }
  ),
  on(
    SubscriptionsApiActions.retrievedActiveSubscription,
    (state, { activeSubscription }): SubscriptionsState => {
      return {
        ...state,
        isLoadingActiveSubscription: false,
        activeSubscription,
      };
    }
  ),
  on(
    SubscriptionsApiActions.fetchFormerSubscriptions,
    (state): SubscriptionsState => {
      return {
        ...state,
        isLoadingFormerSubscriptions: true,
      };
    }
  ),
  on(
    SubscriptionsApiActions.retrievedFormerSubscriptions,
    (state, { formerSubscriptions }): SubscriptionsState => {
      return {
        ...state,
        isLoadingFormerSubscriptions: false,
        formerSubscriptions,
      };
    }
  ),
  on(
    SubscriptionsActions.addActiveSubscription,
    (state, { activeSubscription }): SubscriptionsState => {
      return {
        ...state,
        activeSubscription,
      };
    }
  ),
  on(
    SubscriptionsActions.removeActiveSubscription,
    (state): SubscriptionsState => {
      return {
        ...state,
        activeSubscription: null,
        formerSubscriptions: [
          state.activeSubscription,
          ...state.formerSubscriptions,
        ],
      };
    }
  ),
  on(
    SubscriptionsActions.changeFamilyOption,
    (state, { familyOption }): SubscriptionsState => {
      return {
        ...state,
        activeSubscription: {
          ...state.activeSubscription,
          familyOption,
        },
      };
    }
  ),
  on(
    SubscriptionsApiActions.retrievedFamilyMembers,
    (state, { memberEmails }): SubscriptionsState => {
      return {
        ...state,
        activeSubscription: {
          ...state.activeSubscription,
          familyOption: {
            ...state.activeSubscription.familyOption,
            members: memberEmails,
          },
        },
      };
    }
  ),
  on(SubscriptionsApiActions.failed, (state): SubscriptionsState => {
    return {
      ...state,
      isLoadingActiveSubscription: false,
      isLoadingFormerSubscriptions: false,
    };
  }),
  on(
    SubscriptionsActions.reset,
    (): SubscriptionsState => initialSubscriptionsState
  )
);
